// RU-STRATSTATUS SS-3/SS-4/SS-7: compact current-trading-state chip shown next to the strategy ref. Display only.
import { strategyStatus } from "@/lib/strategyStatus";

const MODE_CLS = {
  live: "border-[var(--live-badge)] text-[var(--live-badge)]",
  paper: "border-[var(--border-strong)] txt-secondary",
};
const STATE_CLS = {
  running: "text-[var(--profit)]",
  paused: "text-[var(--warn)]",
  exits_only: "text-[var(--warn)]",
  not_deployed: "txt-secondary",
  retired: "txt-secondary",
};

export default function StrategyStatusChip({ src, openPosition = false, testid, className = "" }) {
  const st = strategyStatus(src, { openPosition });
  if (!st) return null;
  const t = (suffix) => (testid ? `${testid}${suffix}` : undefined);
  return (
    <span className={`inline-flex items-center gap-1 font-section text-[10px] leading-none px-1.5 py-0.5 rounded-sm border bg-[var(--bg-surface-2)] whitespace-nowrap align-middle ${MODE_CLS[st.mode] || "border-[var(--border-strong)] txt-secondary"} ${className}`}
          title={st.title} onClick={(e) => e.stopPropagation()} data-testid={testid}
          data-mode={st.mode || "none"} data-state={st.state}>
      {st.mode && <span className="font-semibold tracking-wider" data-testid={t("-mode")}>{st.mode === "live" ? "LIVE" : "PAPER"}</span>}
      <span className={`tracking-wider ${STATE_CLS[st.state]}`} data-testid={t("-state")}>{st.label}</span>
      {st.autopilot && <span className="tracking-wider text-[var(--accent)]" data-testid={t("-autopilot")}>AUTOPILOT</span>}
    </span>
  );
}
